import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { File as CustomFile, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAthletePackage(): UseMutationResult<
  AxiosResponse<CustomFile>,
  AxiosError<ErrorMessage>,
  Omit<CustomFile, 'file'> & { file: File | null }
> {
  const queryClient = useQueryClient();

  const updateAthletePackage = (
    file: Omit<CustomFile, 'file'> & { file: File | null },
  ): Promise<AxiosResponse<CustomFile & { file: File | null }>> => {
    const formData = new FormData();
    formData.append('file', file.file || '');
    formData.append('fileType', file.fileType);
    formData.append('filename', file.filename || '');
    formData.append('description', file.description || '');
    formData.append('athlete', file.athlete || '');
    formData.append('createdAt', file.createdAt);
    formData.append('updatedAt', file.updatedAt);
    formData.append('gym', file.gym);
    formData.append('file_id', file.fileId);
    return client.put(`files/${file.fileId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return useMutation(updateAthletePackage, {
    onSuccess: () => {
      queryClient.invalidateQueries(['files']);
    },
  });
}
